declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

type MetaEventParams = Record<string, string | number | boolean>;

const isFbqReady = (): boolean =>
  typeof window !== "undefined" && typeof window.fbq === "function";

export function trackPageView(): void {
  if (!isFbqReady()) return;
  window.fbq!("track", "PageView");
}

export function trackEvent(eventName: string, params?: MetaEventParams): void {
  if (!isFbqReady()) return;
  window.fbq!("track", eventName, params);
}

export function trackCustomEvent(eventName: string, params?: MetaEventParams): void {
  if (!isFbqReady()) return;
  window.fbq!("trackCustom", eventName, params);
}
